module.exports = __webpack_public_path__ + "static/media/dropbox.f5f51158.svg";